import React, { useState, useEffect } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import UserService from "../../services/UserService";
import { deletePermission, postPermission, getPermission } from "../../services/ConfigServices";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import { alpha, styled } from '@mui/material/styles';

import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";

import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '14px',
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    ". &MuiInputBase-input": {
      fontFamily: '"Source Sans Pro",sans-serif',
      fontSize: '14px',
    }
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-multiline": {
      height: "auto",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .Mui-disabled": {
      color: "#000000",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '14px',
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '14px',
  },
  switch: {
    marginLeft: "0.5rem",
  },
  formControl: {
    fontSize: "14px",
    height: "45px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
}));

const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "#91C73C",
    '&:hover': {
      backgroundColor: alpha("#91C73C", 0.04),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: "#91C73C",
  },
}));

export default function TabPanelContent(props) {
  const currentusertype = localStorage.getItem('userType');
  const memv2versionactive = localStorage.getItem('memv2version');
  const options = JSON.parse(localStorage.getItem('memoptions')) || [];
  const mbmoption = options.find((x) => x.id === 'mbm') || currentusertype == 1;
  const importoption = options.find((x) => x.id === 'import') || currentusertype == 1;
  const mapsoption = options.find((x) => x.id === 'maps') || currentusertype == 1;
  const alertesoption = options.find((x) => x.id === 'alertes') || currentusertype == 1;
  const metersoption = options.find((x) => x.id === 'meters') || currentusertype == 1;
  const billsoption = options.find((x) => x.id === 'bills') || currentusertype == 1;
  const budgetsoption = options.find((x) => x.id === 'budget') || currentusertype == 1;
  const actionplansoption = options.find((x) => x.id === 'actionplans') || currentusertype == 1;
  const exportsoption = options.find((x) => x.id === 'exports') || currentusertype == 1;
  const marketsoption = options.find((x) => x.id === 'markets') || currentusertype == 1;
  const ceeoption = options.find((x) => x.id === 'cee') || currentusertype == 1;
  const eventsoption = options.find((x) => x.id === 'events') || currentusertype == 1;
  const mbmgeboption = options.find((x) => x.id === 'geb') || currentusertype == 1;
  console.log(mbmoption);

  const [id, setId] = useState("");
  const [name, setName] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleDelete = async (event) => {
    let permissionid = id;
    setId(null); //trick to hide panel content
    props.setValue(0);
    axios
      .delete(
        deletePermission(permissionid),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Permission supprimée");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        props.fetchData();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleEdit = async (event) => {
    let detail = [
      "mem_access",
      alerts_access,
      alerts_acquit,
      alerts_admin,
      realestate_access,
      realestate_update,
      realestate_create,
      data_read,
      data_update,
      actionplan_read,
      actionplan_update,
      actionplan_create,
      actionplan_admin,
      ged_read,
      ged_comment,
      ged_update,
      view_update,
      view_create,
      exports_read,
      exports_update,
      exports_create,
      bills_admin,
      bills_access,
      budget_access,
      budget_update,
      budget_admin,
      markets_access,
      markets_update,
      markets_admin,
      cee_access,
      cee_update,
      cee_admin,
      mbm_access,
      mbm_admin,
      mbm_campaigns_dashboard,
      mbm_campaigns_read,
      mbm_campaigns_manage,
      mbm_campaigns_admin,
      events_access,
      events_admin,
      mbm_geb_admin,
      mbm_geb_access,
      mbm_geb_control_admin_override,
      mbm_geb_control_admin,
      mbm_geb_control_schedules,
      mbm_geb_control_access,
    ];
    detail = detail.filter((word) => word !== "");
    if (checkedMapsState === true) {
      detail.push("maps_access");
    }
    if (checkedAnalysisState === true) {
      detail.push("analysis_access");
    }

    axios
      .put(
        postPermission(),
        {
          id,
          name,
          detail,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Permission modifiée");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        props.fetchData();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const [checkedMapsState, setCheckedMapsState] = useState(false);
  const [checkedAnalysisState, setCheckedAnalysisState] = useState(false);
  const [alerts, setAlerts] = useState("");
  const [realestate, setRealestate] = useState("");
  const [data, setData] = useState("");
  const [actionplan, setActionplan] = useState("");
  const [GED, setGED] = useState("");
  const [view, setView] = useState("");
  const [exportpage, setExportPage] = useState("");
  const [bills, setBills] = useState("");
  const [budget, setBudget] = useState("");
  const [events, setEvents] = useState("");
  const [markets, setMarkets] = useState("");
  const [cee, setCee] = useState("");
  const [mbm, setMbm] = useState("");
  const [mbm_campaigns, setMbm_campaigns] = useState("");
  const [mbm_geb, setMbm_geb] = useState("");
  const [mbm_geb_control, setMbm_geb_control] = useState("");

  const [maps_access, setMaps_Access] = useState("");
  const [analysis_access, setAnalysis_Access] = useState("");
  const [alerts_access, setAlerts_Access] = useState("");
  const [alerts_acquit, setAlerts_Acquit] = useState("");
  const [alerts_admin, setAlerts_Admin] = useState("");
  const [realestate_access, setRealestate_Access] = useState("");
  const [realestate_update, setRealestate_Update] = useState("");
  const [realestate_create, setRealestate_Create] = useState("");
  const [data_read, setData_Read] = useState("");
  const [data_update, setData_Update] = useState("");
  const [actionplan_read, setActionplan_Read] = useState("");
  const [actionplan_update, setActionplan_Update] = useState("");
  const [actionplan_create, setActionplan_Create] = useState("");
  const [actionplan_admin, setActionplan_Admin] = useState("");
  const [ged_read, setGed_Read] = useState("");
  const [ged_comment, setGed_Comment] = useState("");
  const [ged_update, setGed_Update] = useState("");
  const [view_update, setView_Update] = useState("");
  const [view_create, setView_Create] = useState("");
  const [exports_read, setExports_Read] = useState("");
  const [exports_update, setExports_Update] = useState("");
  const [exports_create, setExports_Create] = useState("");
  const [bills_admin, setBills_Admin] = useState("");
  const [bills_access, setBills_Access] = useState("");
  const [markets_access, setMarkets_Access] = useState("");
  const [markets_update, setMarkets_Update] = useState("");
  const [markets_admin, setMarkets_Admin] = useState("");
  const [cee_access, setCee_Access] = useState("");
  const [cee_update, setCee_Update] = useState("");
  const [cee_admin, setCee_Admin] = useState("");
  const [mbm_access, setMbm_access] = useState("");
  const [mbm_admin, setMbm_admin] = useState("");
  const [mbm_campaigns_dashboard, setMbm_campaigns_dashboard] = useState("");
  const [mbm_campaigns_read, setMbm_campaigns_read] = useState("");
  const [mbm_campaigns_manage, setMbm_campaigns_manage] = useState("");
  const [mbm_campaigns_admin, setMbm_campaigns_admin] = useState("");
  const [budget_access, setBudget_Access] = useState("");
  const [budget_update, setBudget_Update] = useState("");
  const [budget_admin, setBudget_Admin] = useState("");
  const [events_access, setEvents_Access] = useState("");
  const [events_admin, setEvents_Admin] = useState("");
  const [mbm_geb_admin, setMbm_geb_admin] = useState("");
  const [mbm_geb_access, setMbm_geb_access] = useState("");
  const [mbm_geb_control_admin_override, setMbm_geb_control_admin_override] = useState("");
  const [mbm_geb_control_admin, setMbm_geb_control_admin] = useState("");
  const [mbm_geb_control_schedules, setMbm_geb_control_schedules] = useState("");
  const [mbm_geb_control_access, setMbm_geb_control_access] = useState("");

  const handleAlertsChange = (event) => {
    setAlerts(event.target.value);
    setAlerts_Access('');
    setAlerts_Acquit('');
    setAlerts_Admin('');
    if (event.target.value === 'alerts_access') {
      setAlerts_Access('alerts_access');
    }
    else if (event.target.value === 'alerts_acquit') {
      setAlerts_Access('alerts_access');
      setAlerts_Acquit('alerts_acquit');
    }
    else if (event.target.value === 'alerts_admin') {
      setAlerts_Access('alerts_access');
      setAlerts_Acquit('alerts_acquit');
      setAlerts_Admin('alerts_admin');
    }
  };
  const handleBudgetChange = (event) => {
    setBudget(event.target.value);
    setBudget_Access('');
    setBudget_Update('');
    setBudget_Admin('');
    if (event.target.value === 'budget_access') {
      setBudget_Access('budget_access');
    }
    else if (event.target.value === 'budget_update') {
      setBudget_Access('budget_access');
      setBudget_Update('budget_update');
    }
    else if (event.target.value === 'budget_admin') {
      setBudget_Access('budget_access');
      setBudget_Update('budget_update');
      setBudget_Admin('budget_admin');
    }
  };
  const handleEventsChange = (event) => {
    setEvents(event.target.value);
    setEvents_Access('');
    setEvents_Admin('');
    if (event.target.value === 'events_access') {
      setEvents_Access('events_access');
    }
    else if (event.target.value === 'events_admin') {
      setEvents_Access('events_access');
      setEvents_Admin('events_admin');
    }
  };
  const handleRealestateChange = (event) => {
    setRealestate(event.target.value);
    setRealestate_Access('');
    setRealestate_Update('');
    setRealestate_Create('');
    if (event.target.value === 'realestate_access') {
      setRealestate_Access('realestate_access');
    }
    else if (event.target.value === 'realestate_update') {
      setRealestate_Access('realestate_access');
      setRealestate_Update('realestate_update');
    }
    else if (event.target.value === 'realestate_create') {
      setRealestate_Access('realestate_access');
      setRealestate_Update('realestate_update');
      setRealestate_Create('realestate_create');
    }
  };
  const handleBillsChange = (event) => {
    setBills(event.target.value);
    setBills_Access('');
    setBills_Admin('');
    if (event.target.value === 'bills_access') {
      setBills_Access('bills_access');
    }
    else if (event.target.value === 'bills_admin') {
      setBills_Access('bills_access');
      setBills_Admin('bills_access');
    }
  }

  const handleDataChange = (event) => {
    setData(event.target.value);
    setData_Read('');
    setData_Update('');
    if (event.target.value === 'data_read') {
      setData_Read('data_read');
    }
    else if (event.target.value === 'data_update') {
      setData_Read('data_read');
      setData_Update('data_update');
    }
  };
  const handleActionplanChange = (event) => {
    setActionplan(event.target.value);
    setActionplan_Read('');
    setActionplan_Update('');
    setActionplan_Create('');
    setActionplan_Admin('');
    if (event.target.value === 'actionplan_read') {
      setActionplan_Read('actionplan_read');
    }
    else if (event.target.value === 'actionplan_update') {
      setActionplan_Read('actionplan_read');
      setActionplan_Update('actionplan_update');
    }
    else if (event.target.value === 'actionplan_create') {
      setActionplan_Read('actionplan_read');
      setActionplan_Update('actionplan_update');
      setActionplan_Create('actionplan_create');
    }
    else if (event.target.value === 'actionplan_admin') {
      setActionplan_Read('actionplan_read');
      setActionplan_Update('actionplan_update');
      setActionplan_Create('actionplan_create');
      setActionplan_Admin('actionplan_admin');
    }
  };
  const handleGEDChange = (event) => {
    setGED(event.target.value);
    setGed_Read('');
    setGed_Comment('');
    setGed_Update('');
    if (event.target.value === 'ged_read') {
      setGed_Read('ged_read');
    }
    else if (event.target.value === 'ged_comment') {
      setGed_Read('ged_read');
      setGed_Comment('ged_comment');
    }
    else if (event.target.value === 'ged_update') {
      setGed_Read('ged_read');
      setGed_Comment('ged_comment');
      setGed_Update('ged_update');
    }
  };
  const handleViewChange = (event) => {
    setView(event.target.value);
    setView_Update('');
    setView_Create('');
    if (event.target.value === 'view_update') {
      setView_Update('view_update');
    }
    else if (event.target.value === 'view_create') {
      setView_Update('view_update');
      setView_Create('view_create');
    }
  };
  const handleExportChange = (event) => {
    setExportPage(event.target.value);
    setExports_Read('');
    setExports_Update('');
    setExports_Create('');
    if (event.target.value === 'exports_read') {
      setExports_Read('exports_read');
    }
    else if (event.target.value === 'exports_update') {
      setExports_Read('exports_read');
      setExports_Update('exports_update');
    }
    else if (event.target.value === 'exports_create') {
      setExports_Read('exports_read');
      setExports_Update('exports_update');
      setExports_Create('exports_create');
    }
  };

  const handleMarketsChange = (event) => {
    setMarkets(event.target.value);
    setMarkets_Access('');
    setMarkets_Update('');
    setMarkets_Admin('');
    if (event.target.value === 'markets_access') {
      setMarkets_Access('markets_access');
    }
    else if (event.target.value === 'markets_update') {
      setMarkets_Access('markets_access');
      setMarkets_Update('markets_update');
    }
    else if (event.target.value === 'markets_admin') {
      setMarkets_Access('markets_access');
      setMarkets_Update('markets_update');
      setMarkets_Admin('markets_admin');
    }
  }

  const handleCeeChange = (event) => {
    setCee(event.target.value);
    setCee_Access('');
    setCee_Update('');
    setCee_Admin('');
    if (event.target.value === 'cee_access') {
      setCee_Access('cee_access');
    }
    else if (event.target.value === 'cee_update') {
      setCee_Access('cee_access');
      setCee_Update('cee_update');
    }
    else if (event.target.value === 'cee_admin') {
      setCee_Access('cee_access');
      setCee_Update('cee_update');
      setCee_Admin('cee_admin');
    }
  }

  const handleMBMChange = (event) => {
    setMbm(event.target.value);
    setMbm_access('');
    setMbm_admin('');
    if (event.target.value === 'mbm_access') {
      setMbm_access('mbm_access');
    }
    else if (event.target.value === 'mbm_admin') {
      setMbm_access('mbm_access');
      setMbm_admin('mbm_admin');
    }
  }

  const handleMBMCampaignsChange = (event) => {
    setMbm_campaigns(event.target.value);
    setMbm_campaigns_dashboard('');
    setMbm_campaigns_read('');
    setMbm_campaigns_manage('');
    setMbm_campaigns_admin('');
    if (event.target.value === 'mbm_campaigns_dashboard') {
      setMbm_campaigns_dashboard('mbm_campaigns_dashboard');
    }
    else if (event.target.value === 'mbm_campaigns_read') {
      setMbm_campaigns_dashboard('mbm_campaigns_dashboard');
      setMbm_campaigns_read('mbm_campaigns_read');
    }
    else if (event.target.value === 'mbm_campaigns_manage') {
      setMbm_campaigns_dashboard('mbm_campaigns_dashboard');
      setMbm_campaigns_read('mbm_campaigns_read');
      setMbm_campaigns_manage('mbm_campaigns_manage');
    }
    else if (event.target.value === 'mbm_campaigns_admin') {
      setMbm_campaigns_dashboard('mbm_campaigns_dashboard');
      setMbm_campaigns_read('mbm_campaigns_read');
      setMbm_campaigns_manage('mbm_campaigns_manage');
      setMbm_campaigns_admin('mbm_campaigns_admin');
    }
  }

  const handleMBMGEBChange = (event) => {
    setMbm_geb(event.target.value);
    setMbm_geb_admin('');
    setMbm_geb_access('');
    if (event.target.value === 'mbm_geb_access') {
      setMbm_geb_access('mbm_geb_access');
    }
    else if (event.target.value === 'mbm_geb_admin') {
      setMbm_geb_access('mbm_geb_access');
      setMbm_geb_admin('mbm_geb_admin');
    }
  }

  const handleMBMGEBControlChange = (event) => {
    setMbm_geb_control(event.target.value);
    setMbm_geb_control_admin('');
    setMbm_geb_control_admin_override('');
    setMbm_geb_control_schedules('');
    setMbm_geb_control_access('');
    if (event.target.value === 'mbm_geb_control_access') {
      setMbm_geb_control_access('mbm_geb_control_access');
    }
    else if (event.target.value === 'mbm_geb_control_schedules') {
      setMbm_geb_control_schedules('mbm_geb_control_schedules');
      setMbm_geb_control_access('mbm_geb_control_access');
    }
    else if (event.target.value === 'mbm_geb_control_admin') {
      setMbm_geb_control_admin('mbm_geb_control_admin');
      setMbm_geb_control_schedules('mbm_geb_control_schedules');
      setMbm_geb_control_access('mbm_geb_control_access');
    }
    else if (event.target.value === 'mbm_geb_control_admin_override') {
      setMbm_geb_control_admin('mbm_geb_control_admin');
      setMbm_geb_control_schedules('mbm_geb_control_schedules');
      setMbm_geb_control_access('mbm_geb_control_access');
      setMbm_geb_control_admin_override('mbm_geb_control_admin_override');
    }
  }

  useEffect(() => {
    axios
      .get(
        getPermission(props.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setName(res.data.name);
        setId(res.data.id);

        setMaps_Access("");
        setAnalysis_Access("");
        setAlerts_Access("");
        setAlerts_Acquit("");
        setAlerts_Admin("");
        setRealestate_Access("");
        setRealestate_Update("");
        setRealestate_Create("");
        setData_Read("");
        setData_Update("");
        setActionplan_Read("");
        setActionplan_Update("");
        setActionplan_Create("");
        setActionplan_Admin("");
        setGed_Read("");
        setGed_Comment("");
        setGed_Update("");
        setView_Update("");
        setView_Create("");
        setExports_Read("");
        setExports_Update("");
        setExports_Create("");
        setBills_Access('');
        setBills_Admin('');
        setMarkets_Access('');
        setMarkets_Update('');
        setMarkets_Admin('');
        setCee_Access('');
        setCee_Update('');
        setCee_Admin('');
        setMbm_access('');
        setMbm_admin('');
        setMbm_campaigns_dashboard('');
        setMbm_campaigns_read('');
        setMbm_campaigns_manage('');
        setMbm_campaigns_admin('');
        setBudget_Access('');
        setBudget_Update('');
        setBudget_Admin('');
        setEvents_Access('');
        setEvents_Admin('');
        setMbm_geb_admin('');
        setMbm_geb_access('');
        setMbm_geb_control_admin_override('');
        setMbm_geb_control_admin('');
        setMbm_geb_control_schedules('');
        setMbm_geb_control_access('');

        if (res.data.detail.includes("maps_access")) {
          setCheckedMapsState(true);
          setMaps_Access("maps_access");
        }
        else
          setCheckedMapsState(false);
        if (res.data.detail.includes("analysis_access")) {
          setCheckedAnalysisState(true);
          setAnalysis_Access("analysis_access");
        }
        else
          setCheckedAnalysisState(false);

        setAlerts("alerts_none");
        if (res.data.detail.includes("alerts_access")) {
          setAlerts("alerts_access");
          setAlerts_Access("alerts_access");
        } if (res.data.detail.includes("alerts_acquit")) {
          setAlerts("alerts_acquit");
          setAlerts_Access("alerts_access");
          setAlerts_Acquit("alerts_acquit");
        } if (res.data.detail.includes("alerts_admin")) {
          setAlerts("alerts_admin");
          setAlerts_Access("alerts_access");
          setAlerts_Acquit("alerts_acquit");
          setAlerts_Admin("alerts_admin");
        }


        setRealestate("realestate_none");
        if (res.data.detail.includes("realestate_access")) {
          setRealestate("realestate_access");
          setRealestate_Access("realestate_access");
        } if (res.data.detail.includes("realestate_update")) {
          setRealestate("realestate_update");
          setRealestate_Access("realestate_access");
          setRealestate_Update("realestate_update");
        } if (res.data.detail.includes("realestate_create")) {
          setRealestate("realestate_create");
          setRealestate_Access("realestate_access");
          setRealestate_Update("realestate_update");
          setRealestate_Create("realestate_create");
        }

        setBudget("budget_none");
        if (res.data.detail.includes("budget_access")) {
          setBudget("budget_access");
          setBudget_Access("realestate_access");
        } if (res.data.detail.includes("budget_update")) {
          setBudget("budget_update");
          setBudget_Access("budget_access");
          setBudget_Update("budget_update");
        } if (res.data.detail.includes("budget_admin")) {
          setBudget("budget_admin");
          setBudget_Access("budget_access");
          setBudget_Update("budget_update");
          setBudget_Admin('budget_admin');
        }

        setEvents("events_none");
        if (res.data.detail.includes("events_access")) {
          setEvents("events_access");
          setEvents_Access("events_access");
        } if (res.data.detail.includes("events_admin")) {
          setEvents("events_admin");
          setEvents_Access("events_access");
          setEvents_Admin('events_admin');
        }

        setBills('bills_none');
        if (res.data.detail.includes("bills_access")) {
          setBills('bills_access');
          setBills_Access('bills_access');
        }
        else if (res.data.detail.includes("bills_admin")) {
          setBills('bills_access');
          setBills_Access('bills_access');
          setBills_Admin('bills_access');
        }

        setData("data_none");
        if (res.data.detail.includes("data_read")) {
          setData("data_read");
          setData_Read("data_read");
        } if (res.data.detail.includes("data_update")) {
          setData("data_update");
          setData_Read("data_read");
          setData_Update("data_update");
        }

        setActionplan("actionplan_none");
        if (res.data.detail.includes("actionplan_read")) {
          setActionplan("actionplan_read");
          setActionplan_Read("actionplan_read");
        } if (res.data.detail.includes("actionplan_update")) {
          setActionplan("actionplan_update");
          setActionplan_Read("actionplan_read");
          setActionplan_Update("actionplan_update");
        }
        if (res.data.detail.includes("actionplan_create")) {
          setActionplan("actionplan_create");
          setActionplan_Read("actionplan_read");
          setActionplan_Update("actionplan_update");
          setActionplan_Create("actionplan_create");
        } if (res.data.detail.includes("actionplan_admin")) {
          setActionplan("actionplan_admin");
          setActionplan_Read("actionplan_read");
          setActionplan_Update("actionplan_update");
          setActionplan_Create("actionplan_create");
          setActionplan_Admin("actionplan_admin");
        }

        setGED("ged_none");
        if (res.data.detail.includes("ged_read")) {
          setGED("ged_read");
          setGed_Read("ged_read");
        } if (res.data.detail.includes("ged_comment")) {
          setGED("ged_comment");
          setGed_Read("ged_read");
          setGed_Comment("ged_comment");
        } if (res.data.detail.includes("ged_update")) {
          setGED("ged_update");
          setGed_Read("ged_read");
          setGed_Comment("ged_comment");
          setGed_Update("ged_update");
        }

        setView("view_none");
        if (res.data.detail.includes("view_update")) {
          setView("view_update");
          setView_Update("view_update");
        } if (res.data.detail.includes("view_create")) {
          setView("view_create");
          setView_Update("view_update");
          setView_Create("view_create");
        }

        setExportPage("exports_none");
        if (res.data.detail.includes("exports_read")) {
          setExportPage("exports_read");
          setExports_Read("exports_read");
        } if (res.data.detail.includes("exports_update")) {
          setExportPage("exports_update");
          setExports_Read("exports_read");
          setExports_Update("exports_update");
        } if (res.data.detail.includes("exports_create")) {
          setExportPage("exports_create");
          setExports_Read("exports_read");
          setExports_Update("exports_update");
          setExports_Create("exports_create");
        }

        setMarkets("markets_none");
        if (res.data.detail.includes("markets_access")) {
          setMarkets("markets_access");
          setMarkets_Access("markets_access");
        } if (res.data.detail.includes("markets_update")) {
          setMarkets("markets_update");
          setMarkets_Access("markets_access");
          setMarkets_Update("markets_update");
        } if (res.data.detail.includes("markets_admin")) {
          setMarkets("markets_admin");
          setMarkets_Access("markets_access");
          setMarkets_Update("markets_update");
          setMarkets_Admin("markets_admin");
        }

        setCee("cee_none");
        if (res.data.detail.includes("cee_access")) {
          setCee("cee_access");
          setCee_Access("cee_access");
        } if (res.data.detail.includes("cee_update")) {
          setCee("cee_update");
          setCee_Access("cee_access");
          setCee_Update("cee_update");
        } if (res.data.detail.includes("cee_admin")) {
          setCee("cee_admin");
          setCee_Access("cee_access");
          setCee_Update("cee_update");
          setCee_Admin("cee_admin");
        }

        setMbm('mbm_none');
        if (res.data.detail.includes("mbm_access")) {
          setMbm("mbm_access");
          setMbm_access("mbm_access");
        } if (res.data.detail.includes("mbm_admin")) {
          setMbm("mbm_admin");
          setMbm_access("mbm_access");
          setMbm_admin("mbm_admin");
        }

        setMbm_campaigns("mbm_campaigns_none");
        if (res.data.detail.includes("mbm_campaigns_dashboard")) {
          setMbm_campaigns("mbm_campaigns_dashboard");
          setMbm_campaigns_dashboard("mbm_campaigns_dashboard");
        } if (res.data.detail.includes("mbm_campaigns_read")) {
          setMbm_campaigns("mbm_campaigns_read");
          setMbm_campaigns_dashboard("mbm_campaigns_dashboard");
          setMbm_campaigns_read("mbm_campaigns_read");
        } if (res.data.detail.includes("mbm_campaigns_manage")) {
          setMbm_campaigns("mbm_campaigns_manage");
          setMbm_campaigns_dashboard("mbm_campaigns_dashboard");
          setMbm_campaigns_read("mbm_campaigns_read");
          setMbm_campaigns_manage("mbm_campaigns_manage");
        }
        if (res.data.detail.includes("mbm_campaigns_admin")) {
          setMbm_campaigns("mbm_campaigns_admin");
          setMbm_campaigns_dashboard("mbm_campaigns_dashboard");
          setMbm_campaigns_read("mbm_campaigns_read");
          setMbm_campaigns_manage("mbm_campaigns_manage");
          setMbm_campaigns_admin("mbm_campaigns_admin");
        }

        setMbm_geb('mbm_geb_none');
        if (res.data.detail.includes("mbm_geb_access")) {
          setMbm_geb("mbm_geb_access");
          setMbm_geb_access("mbm_geb_access");
        } if (res.data.detail.includes("mbm_geb_admin")) {
          setMbm_geb("mbm_geb_admin");
          setMbm_geb_access("mbm_geb_access");
          setMbm_geb_admin('mbm_geb_admin');
        }

        setMbm_geb_control('mbm_geb_control_none');
        if (res.data.detail.includes("mbm_geb_control_access")) {
          setMbm_geb_control("mbm_geb_control_access");
          setMbm_geb_control_access('mbm_geb_control_access');
        } if (res.data.detail.includes("mbm_geb_control_schedules")) {
          setMbm_geb_control("mbm_geb_control_schedules");
          setMbm_geb_control_access('mbm_geb_control_access');
          setMbm_geb_control_schedules('mbm_geb_control_schedules');
        } if (res.data.detail.includes("mbm_geb_control_admin")) {
          setMbm_geb_control("mbm_geb_control_admin");
          setMbm_geb_control_access('mbm_geb_control_access');
          setMbm_geb_control_schedules('mbm_geb_control_schedules');
          setMbm_geb_control_admin('mbm_geb_control_admin');
        } if (res.data.detail.includes("mbm_geb_control_admin_override")) {
          setMbm_geb_control("mbm_geb_control_admin_override");
          setMbm_geb_control_access('mbm_geb_control_access');
          setMbm_geb_control_schedules('mbm_geb_control_schedules');
          setMbm_geb_control_admin('mbm_geb_control_admin');
          setMbm_geb_control_admin_override('mbm_geb_control_admin_override');
        }

      });
  }, []);

  const classes = useStyles();

  return (
    <div>
      {id ? (
        <GridContainer>

          <GridItem xs={12} sm={12} md={6}>
            <div>
              <div className={classes.input}>
                <div className={classes.inputTitle}>Nom de la permission</div>
                <TextField
                  required
                  variant="outlined"
                  id="permissionName-required-outlined-size-small"
                  label=""
                  style={{
                    margin: "2px 8px", fontFamily: '"Source Sans Pro",sans-serif',
                    fontSize: '14px',
                  }}
                  //defaultValue={name}
                  value={name}
                  onChange={handleNameChange}
                  className={classes.textField}
                />
              </div>
            </div>
            {alertesoption ?
              <div className={classes.select}>
                <div style={{ margin: "0.2rem 0rem" }}>Alertes</div>{" "}
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    labelId="alerts-simple-select-outlined-label"
                    id="alerts-simple-select-outlined"
                    value={alerts}
                    onChange={handleAlertsChange}
                    className={classes.textField}
                  >
                    <MenuItem value={"alerts_none"}>
                      <em>Aucun droit</em>
                    </MenuItem>
                    <MenuItem value={"alerts_access"}>Lecture</MenuItem>
                    <MenuItem value={"alerts_acquit"}>Lecture et acquittement</MenuItem>
                    {memv2versionactive > 0 ?
                      <MenuItem value={"alerts_admin"}>Lecture, acquittement et création</MenuItem> : <></>
                    }
                  </Select>
                </FormControl>
              </div> : <></>}
            {eventsoption ?
              <div className={classes.select}>
                <div style={{ margin: "0.2rem 0rem" }}>Evènements</div>{" "}
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    labelId="events-simple-select-outlined-label"
                    id="events-simple-select-outlined"
                    value={events}
                    onChange={handleEventsChange}
                    className={classes.textField}
                  >
                    <MenuItem value={"events_none"}>
                      <em>Aucun droit</em>
                    </MenuItem>
                    <MenuItem value={"events_access"}>Lecture</MenuItem>
                    <MenuItem value={"events_admin"}>Lecture et création</MenuItem>
                  </Select>
                </FormControl>
              </div> : <></>}
            <div className={classes.select}>
              <div style={{ margin: "0.2rem 0rem" }}>Patrimoine</div>{" "}
              <FormControl variant="outlined" className={classes.formControl}>
                <Select
                  labelId="realestate-simple-select-outlined-label"
                  id="realestate-simple-select-outlined"
                  value={realestate}
                  onChange={handleRealestateChange}
                  className={classes.textField}
                >
                  <MenuItem value={"realestate_none"}>
                    <em>Aucun droit</em>
                  </MenuItem>
                  <MenuItem value={"realestate_access"}>Lecture</MenuItem>
                  <MenuItem value={"realestate_update"}>Lecture et modification</MenuItem>
                  <MenuItem value={"realestate_create"}>Lecture, modification et création</MenuItem>
                </Select>
              </FormControl>
            </div>
            {billsoption ?
              <div className={classes.select}>
                <div style={{ margin: "0.2rem 0rem" }}>Factures</div>{" "}
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    labelId="bills-simple-select-outlined-label"
                    id="bills-simple-select-outlined"
                    value={bills}
                    onChange={handleBillsChange}
                    className={classes.textField}
                  >
                    <MenuItem value={"bills_none"}>
                      <em>Aucun droit</em>
                    </MenuItem>
                    <MenuItem value={"bills_access"}>Lecture</MenuItem>
                    <MenuItem value={"bills_admin"}>Lecture et modification</MenuItem>
                  </Select>
                </FormControl>
              </div> : <></>}
            {mapsoption ?
              <div style={{ margin: "1.3rem 0rem" }}>
                <div className={classes.inputTitle}>Voir la carte</div>{" "}
                <div className={classes.switch}>
                  <FormControlLabel
                    control={
                      <GreenSwitch
                        checked={checkedMapsState}
                        onChange={(event) => { setCheckedMapsState(event.target.checked) }}
                        name="checkedMaps"
                      />
                    }
                    label=""
                  />
                </div>
              </div> : <></>}
            <div style={{ margin: "2rem 0rem 1rem" }}>
              <div className={classes.inputTitle}>Voir les analyses</div>{" "}
              <div className={classes.switch}>
                <FormControlLabel
                  control={
                    <GreenSwitch
                      checked={checkedAnalysisState}
                      onChange={(event) => { setCheckedAnalysisState(event.target.checked) }}
                      name="checkedAnalysis"
                    />
                  }
                  label=""
                />
              </div>
            </div>
            {budgetsoption ?
              <div className={classes.select}>
                <div style={{ margin: "0.2rem 0rem" }}>Budgets</div>{" "}
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    labelId="budget-simple-select-outlined-label"
                    id="budget-simple-select-outlined"
                    value={budget}
                    onChange={handleBudgetChange}
                    className={classes.textField}
                  >
                    <MenuItem value={"budget_none"}>
                      <em>Aucun droit</em>
                    </MenuItem>
                    <MenuItem value={"budget_access"}>Lecture</MenuItem>
                    <MenuItem value={"budget_update"}>Lecture et modification</MenuItem>
                    <MenuItem value={"budget_admin"}>Lecture, modification et création</MenuItem>
                  </Select>
                </FormControl>
              </div> : <></>}
            {importoption ?
              <div className={classes.select}>
                <div style={{ margin: "0.2rem 0rem" }}>Imports de données</div>{" "}
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    labelId="data-simple-select-outlined-label"
                    id="data-simple-select-outlined"
                    value={data}
                    onChange={handleDataChange}
                    className={classes.textField}
                  >
                    <MenuItem value={"data_none"}>
                      <em>Aucun droit</em>
                    </MenuItem>
                    <MenuItem value={"data_read"}>Lecture</MenuItem>
                    <MenuItem value={"data_update"}>Lecture et import</MenuItem>
                  </Select>
                </FormControl>
              </div> : <></>}
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>


            {(memv2versionactive > 1 && actionplansoption) ?
              <div className={classes.select}>
                <div style={{ margin: "0.2rem 0rem" }}>Plans d'actions</div>{" "}
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    labelId="actionplan-simple-select-outlined-label"
                    id="actionplan-simple-select-outlined"
                    value={actionplan}
                    onChange={handleActionplanChange}
                    className={classes.textField}
                  >
                    <MenuItem value={"actionplan_none"}>
                      <em>Aucun droit</em>
                    </MenuItem>
                    <MenuItem value={"actionplan_read"}>Lecture</MenuItem>
                    <MenuItem value={"actionplan_update"}>Lecture et modification</MenuItem>
                    <MenuItem value={"actionplan_create"}>Lecture, modification et création des actions</MenuItem>
                    <MenuItem value={"actionplan_admin"}>Administration des plans d'actions</MenuItem>
                  </Select>
                </FormControl>
              </div>
              : <></>}

            <div>
              {memv2versionactive > 0 ?
                <div className={classes.select}>
                  <div style={{ margin: "0.2rem 0rem" }}>Documents</div>{" "}
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                      labelId="ged-simple-select-outlined-label"
                      id="ged-simple-select-outlined"
                      value={GED}
                      onChange={handleGEDChange}
                      className={classes.textField}
                    >
                      <MenuItem value={"ged_none"}>
                        <em>Aucun droit</em>
                      </MenuItem>
                      <MenuItem value={"ged_read"}>Lecture</MenuItem>
                      <MenuItem value={"ged_comment"}>Lecture et modification</MenuItem>
                      <MenuItem value={"ged_update"}>Lecture, modification et création</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                : <></>}
              {memv2versionactive > 0 ?
                <div className={classes.select}>
                  <div style={{ margin: "0.2rem 0rem" }}>Vues</div>{" "}
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                      labelId="view-simple-select-outlined-label"
                      id="view-simple-select-outlined"
                      value={view}
                      onChange={handleViewChange}
                      className={classes.textField}
                    >
                      <MenuItem value={"view_none"}>
                        <em>Aucun droit</em>
                      </MenuItem>
                      <MenuItem value={"view_update"}>Modification</MenuItem>
                      <MenuItem value={"view_create"}>Modification et création</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                : <></>}
              {(memv2versionactive > 1 && exportsoption) ?
                <div className={classes.select}>
                  <div style={{ margin: "0.2rem 0rem" }}>Exports</div>{" "}
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                      labelId="simulation-simple-select-outlined-label"
                      id="simulation-simple-select-outlined"
                      value={exportpage}
                      onChange={handleExportChange}
                      className={classes.textField}
                    >
                      <MenuItem value={"exports_none"}>
                        <em>Aucun droit</em>
                      </MenuItem>
                      <MenuItem value={"exports_read"}>Lecture</MenuItem>
                      {/* <MenuItem value={"exports_update"}>Lecture et modification</MenuItem> */}
                      <MenuItem value={"exports_create"}>Lecture, modification et création</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                : <></>}
              {(memv2versionactive > 0 && marketsoption) ?
                <div className={classes.select}>
                  <div style={{ margin: "0.2rem 0rem" }}>Marchés</div>{" "}
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                      labelId="market-simple-select-outlined-label"
                      id="market-simple-select-outlined"
                      value={markets}
                      onChange={handleMarketsChange}
                      className={classes.textField}
                    >
                      <MenuItem value={"markets_none"}>
                        <em>Aucun droit</em>
                      </MenuItem>
                      <MenuItem value={"markets_access"}>Adhérent en lecture seule</MenuItem>
                      <MenuItem value={"markets_update"}>Adhérent avec droits de modification</MenuItem>
                      <MenuItem value={"markets_admin"}>Gestionnaire de marché</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                : <></>}
              {(memv2versionactive > 0 && ceeoption) ?
                <div className={classes.select}>
                  <div style={{ margin: "0.2rem 0rem" }}>CEE</div>{" "}
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                      labelId="cee-simple-select-outlined-label"
                      id="cee-simple-select-outlined"
                      value={cee}
                      onChange={handleCeeChange}
                      className={classes.textField}
                    >
                      <MenuItem value={"cee_none"}>
                        <em>Aucun droit</em>
                      </MenuItem>
                      <MenuItem value={"cee_access"}>Adhérent en lecture seule</MenuItem>
                      <MenuItem value={"cee_update"}>Adhérent avec droits de modification</MenuItem>
                      <MenuItem value={"cee_admin"}>Gestionnaire de campagne</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                : <></>}
              {mbmoption ?
                <>
                  <div className={classes.select}>
                    <div style={{ margin: "0.2rem 0rem" }}>IoT</div>{" "}
                    <FormControl variant="outlined" className={classes.formControl}>
                      <Select
                        labelId="simulation-simple-select-outlined-label"
                        id="simulation-simple-select-outlined"
                        value={mbm}
                        onChange={handleMBMChange}
                        className={classes.textField}
                      >
                        <MenuItem value={"mbm_none"}>
                          <em>Aucun droit</em>
                        </MenuItem>
                        <MenuItem value={"mbm_access"}>Lecture</MenuItem>
                        {/* <MenuItem value={"exports_update"}>Lecture et modification</MenuItem> */}
                        <MenuItem value={"mbm_admin"}>Lecture, modification et création</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.select}>
                    <div style={{ margin: "0.2rem 0rem" }}>Campagnes de mesures IoT</div>{" "}
                    <FormControl variant="outlined" className={classes.formControl}>
                      <Select
                        labelId="simulation-simple-select-outlined-label"
                        id="simulation-simple-select-outlined"
                        value={mbm_campaigns}
                        onChange={handleMBMCampaignsChange}
                        className={classes.textField}
                      >
                        <MenuItem value={"mbm_campaigns_none"}>
                          <em>Aucun droit</em>
                        </MenuItem>
                        <MenuItem value={"mbm_campaigns_dashboard"}>Accès aux tableaux de bords</MenuItem>
                        <MenuItem value={"mbm_campaigns_read"}>Lecture</MenuItem>
                        <MenuItem value={"mbm_campaigns_manage"}>Gestion</MenuItem>
                        <MenuItem value={"mbm_campaigns_admin"}>Administration</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </>
                : <></>}
                {mbmgeboption ?
                <>
                  <div className={classes.select}>
                    <div style={{ margin: "0.2rem 0rem" }}>GEB</div>{" "}
                    <FormControl variant="outlined" className={classes.formControl}>
                      <Select
                        labelId="simulation-simple-select-outlined-label"
                        id="simulation-simple-select-outlined"
                        value={mbm_geb}
                        onChange={handleMBMGEBChange}
                        className={classes.textField}
                      >
                        <MenuItem value={"mbm_geb_none"}>
                          <em>Aucun droit</em>
                        </MenuItem>
                        <MenuItem value={"mbm_geb_access"}>Lecture</MenuItem>
                        {/* <MenuItem value={"exports_update"}>Lecture et modification</MenuItem> */}
                        <MenuItem value={"mbm_geb_admin"}>Lecture, modification et création</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.select}>
                    <div style={{ margin: "0.2rem 0rem" }}>GEB - Pilotage</div>{" "}
                    <FormControl variant="outlined" className={classes.formControl}>
                      <Select
                        labelId="simulation-simple-select-outlined-label"
                        id="simulation-simple-select-outlined"
                        value={mbm_geb_control}
                        onChange={handleMBMGEBControlChange}
                        className={classes.textField}
                      >
                        <MenuItem value={"mbm_geb_control_none"}>
                          <em>Aucun droit</em>
                        </MenuItem>
                        <MenuItem value={"mbm_geb_control_access"}>Lecture</MenuItem>
                        <MenuItem value={"mbm_geb_control_schedules"}>Modification des plannings</MenuItem>
                        <MenuItem value={"mbm_geb_control_admin"}>Administration</MenuItem>
                        <MenuItem value={"mbm_geb_control_admin_override"}>Administration avec dérogation</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </>
                : <></>}
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                marginTop: "2.5rem",
                marginLeft: "auto",
                marginRight: "0.2rem",
              }}
            >

              <Button
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#91C73C",
                  fontWeight: "normal",
                  fontWeight: "bold",
                  height: "40px",
                  fontSize: "0.75rem",
                  padding: "5px 15px",
                  marginRight: "5px",
                  marginBottom: "13px",
                  marginTop: "0px",
                  fontFamily: '"Source Sans Pro",sans-serif',
                }}
                onClick={() => {
                  handleEdit();
                }}
              >
                Modifier
              </Button>
              <CustomDeleteButton
                size="40px"
                deleteTitle={"Suppression de la permission"}
                deleteSubTitle={
                  "Êtes-vous sûr de vouloir supprimer la permission?"
                }
                handleSupprimer={handleDelete}
              >
                Supprimer
              </CustomDeleteButton>
            </div>
          </GridItem>

        </GridContainer>
      ) : <div></div>}

    </div>
  );
}
